import { render, staticRenderFns } from "./OpsReportCard.vue?vue&type=template&id=0b51090d&scoped=true&"
import script from "./OpsReportCard.vue?vue&type=script&lang=js&"
export * from "./OpsReportCard.vue?vue&type=script&lang=js&"
import style0 from "./OpsReportCard.vue?vue&type=style&index=0&id=0b51090d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b51090d",
  null
  
)

export default component.exports